// opervex-frontend/src/services/FileSelectorService.js

const FileSelectorService = {
  /**
   * Abre o seletor de arquivos do navegador.
   *
   * @param {Object} options
   * @param {string} options.accept Tipos de arquivos permitidos
   * @param {boolean} options.multiple Permite selecionar vários arquivos
   *
   * @returns {Promise<File|File[]|null>}
   */
  selectFile: ({ accept = "", multiple = false } = {}) => {
    return new Promise((resolve) => {
      const input = document.createElement("input");

      input.type = "file";
      input.style.display = "none";
      input.accept = accept;
      input.multiple = multiple;

      const cleanup = () => {
        if (document.body.contains(input)) {
          document.body.removeChild(input);
        }
      };

      input.addEventListener(
        "change",
        (event) => {
          const files = Array.from(event.target.files || []);

          cleanup();

          if (!files.length) {
            resolve(null);
            return;
          }

          if (multiple) {
            resolve(files);
            return;
          }

          resolve(files[0]);
        },
        { once: true },
      );

      document.body.appendChild(input);

      input.click();
    });
  },
};

export default FileSelectorService;
